<template>
  <div>
    <Main
      :height="height"
      :loading="loading"
      :tableData="tableData"
      @reload="getData"
      @changePopNum="changePopNum"
      ref="tableMain"
    >
    <Header ref="tableHeader" slot="header" @query="getData" />

    </Main>
  </div>
</template>
<script>
import Main from './main.vue'
import Header from './header.vue'
export default {
  components: { Main, Header },
  props: {
    height: { type: Number, default: 300 },
    data: { type: Object, default: () => {} },
  },
  data() {
    return {
      loading: false,
      tableData: [],
    }
  },
  methods: {
    getData(form) {
      if (!this.data) return
      this.loading = true
      this.$api
        .orderDemandPackageGoodsBatchListApi({
          orderPackingCode: this.data.orderPackingCode,
          ...form,
        })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
    choiceData() {
      return this.$refs.tableMain.choiceData()
    },
    changePopNum(num) {
      this.$emit('changePopNum', num)
    },
  },
}
</script>
